import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    myStories: [],
    stories: [],
};

const storiesSlice = createSlice({
    name: 'stories',
    initialState,
    reducers: {
        setMyStories: (state, action) => {
            state.myStories = action.payload;
        },
        setStories: (state, action) => {
            state.stories = action.payload;
        },
        clearStories: state => {
            state.stories = [];
        },
        removeStoryById: (state, action) => {
            const { storyId, target } = action.payload; // target: 'myStories' | 'stories'
            state[target] = state[target]
                .map(group => ({
                    ...group,
                    stories: group.stories.filter(s => (s.storyId || s.story_id || s.msgId) !== storyId),
                }))
                .filter(group => group.stories.length > 0);
        },
        updateStoryViewerLike: (state, action) => {
            const { storyId, likedBy, liked } = action.payload;
            // Story owner: update viewer's like and sort liked viewers to top
            for (const group of state.myStories) {
                const story = group.stories.find(s => (s.storyId || s.story_id) === storyId);
                if (story) {
                    if (!Array.isArray(story.viewers)) story.viewers = [];
                    const viewer = story.viewers.find(v => v.viewerUsername === likedBy);
                    if (viewer) {
                        viewer.like = liked ? 1 : 0;
                    } else if (liked) {
                        // view IQ hasn't arrived yet — add a placeholder; mergeStoryViewers will fill it in
                        story.viewers.push({ viewerUsername: likedBy, like: 1, viewedAt: new Date().toISOString() });
                    }
                    story.viewers.sort((a, b) => (b.like || 0) - (a.like || 0));
                }
            }
            // Viewer: persist their own like state so it survives reopening
            for (const group of state.stories) {
                const story = group.stories.find(s => (s.storyId || s.story_id) === storyId);
                if (story) {
                    story.liked = liked;
                    return;
                }
            }
        },
        mergeStoryViewers: (state, action) => {
            const { userId, storyId, viewers: incoming } = action.payload;
            if (!Array.isArray(incoming) || incoming.length === 0) return;

            const group = state.myStories.find(g => g.userId === userId);
            if (!group) return;

            const story = group.stories.find(s => (s.storyId || s.story_id) === storyId);
            if (!story) return;

            if (!Array.isArray(story.viewers)) story.viewers = [];

            for (const v of incoming) {
                const idx = story.viewers.findIndex(e => e.viewerUsername === v.viewerUsername);
                if (idx === -1) {
                    story.viewers.push(v);
                } else {
                    story.viewers[idx] = { ...story.viewers[idx], ...v };
                }
            }
            story.viewers.sort((a, b) => (b.like || 0) - (a.like || 0));
        },
    },
});

export const { setMyStories, setStories, clearStories, removeStoryById, mergeStoryViewers, updateStoryViewerLike } =
    storiesSlice.actions;

export default storiesSlice.reducer;
